import {default_params, default_task, default_task_control, default_task_step} from './state';

/**
 * Establecer un valor para la variable tasks.
 */
export function setTasks(state, tasks) {
    state.tasks = tasks;
}

/**
 * Establecer un valor para la variable task.
 */
export function setTask(state, task) {

    let positions = [];

    task.positions.map((position) => {
        positions.push(position.wor_position_id);
    });

    task.positions = positions;

    state.task = task;
}

/**
 * Establecer un valor para el atributo code de la variable task.
 */
export function setCodeToTask(state, code) {
    state.task.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.tasks = {data: []};
}

/**
 * Establecer el valor por defecto de task.
 */
export function resetTask(state) {
    state.task = default_task();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para el atributo show de la variable modal_attachments.
 */
export function setShowToModalAttachments(state, show) {
    state.modal_attachments.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_new_attachment.
 */
export function setShowToModalNewAttachment(state, show) {
    state.modal_new_attachment.show = show;
}

/**
 * Establecer un valor para la variable attachments.
 */
export function setAttachments(state, attachments) {
    state.attachments = attachments;
}

/**
 * Establecer el valor por defecto de la variable default_task_step.
 */
export function resetTaskStep(state) {
    state.task_step = default_task_step();
}

/**
 * Establecer el valor por defecto de la variable default_task_control.
 */
export function resetTaskControl(state) {
    state.task_control = default_task_control();
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function setStepToModal(state, step) {
    state.modal.step = step;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function increaseStepToModal(state) {
    state.modal.step++;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function decreaseStepToModal(state) {
    state.modal.step--;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function addStep(state) {
    let order = 0;

    state.task.steps.map(s => {
        if (s.order > order) {
            order = s.order;
        }
    });

    state.task_step.id = (Math.floor(Math.random() * 10000) + 1) * -1;

    state.task_step.order = order + 1;

    state.task.steps.push(state.task_step);
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function updateStep(state) {
    state.task.steps.map(s => {
        if (state.task_step.id === s.id) {
            s = state.task_step;
        }
    });
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function addControl(state) {
    state.task_control.id = (Math.floor(Math.random() * 10000) + 1) * -1;

    state.task_control.sys_list_type = state.types.find(t => t.id === state.task_control.sys_list_type_id);

    state.task.controls.push(state.task_control);
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function updateControl(state) {
    state.task.controls.map(s => {
        if (state.task_control.id === s.id) {
            s = state.task_control;
        }
    });
}

/**
 * Establecer un valor para el atributo steps de la variable task.
 */
export function setStepsToTask(state, steps) {
    state.task.steps = steps;
}

/**
 * Establecer un valor para la variable task_step.
 */
export function setTaskStep(state, task_step) {
    state.task_step = task_step;
}

/**
 * Establecer un valor para la variable task_control.
 */
export function setTaskControl(state, task_control) {
    state.task_control = task_control;
}

/**
 * Establecer un valor para el atributo controls de la variable task.
 */
export function setControlsToTask(state, controls) {
    state.task.controls = controls;
}

/**
 * Establecer un valor para el atributo url de la variable task.
 */
export function setUrlToTask(state, url) {
    state.task.url = url;

    if (!url) {
        state.task.image = null;
    }
}

/**
 * Establecer un valor para el atributo url de la variable task_step.
 */
export function setUrlToTaskStep(state, url) {
    state.task_step.url = url;

    if (!url) {
        state.task_step.image = null;
    }
}

/**
 * Establecer un valor para el atributo url de la variable task_control.
 */
export function setUrlToTaskControl(state, url) {
    state.task_control.url = url;

    if (!url) {
        state.task_control.image = null;
    }
}

/**
 * Establecer un valor para la variable editing_control.
 */
export function setEditingControl(state, editing_control) {
    state.editing_control = editing_control;
}

/**
 * Establecer un valor para la variable editing_step.
 */
export function setEditingStep(state, editing_step) {
    state.editing_step = editing_step;
}

/**
 * Establecer un valor para la variable modal_image.
 */
export function setModalImage(state, modal_image) {
    state.modal_image = modal_image;
}

/**
 * Establecer un valor para la variable positions.
 */
export function setPositions(state, positions) {
    state.positions = positions;
}

/**
 * Establecer un valor para la variable locations.
 */
export function setLocations(state, locations) {
    state.params.slq_location_id = null;
    state.locations = locations;
}

/**
 * Establecer un valor para el atributo slq_location_id de la variable task.
 */
export function setSlqLocationIdToTask(state, slq_location_id) {
    state.task.slq_location_id = slq_location_id;
}

/**
 * Establecer un valor para el atributo slq_location_id de la variable params.
 */
export function setSlqLocationIdToParams(state, slq_location_id) {
    state.params.slq_location_id = slq_location_id;
}

/**
 * Establecer un valor para el atributo slq_location_id de la variable task desde analisis.
 */
export function setLocationFromAnalysis(state, slq_location_id) {
    state.task.slq_location_id = slq_location_id;
}
